import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import React from 'react';

// Initialize Bugsnag only if API key is available
let bugsnag: any = null;
let BugsnagErrorBoundary: any = null;

const apiKey = import.meta.env.VITE_BUGSNAG_API_KEY;

if (apiKey) {
  try {
    bugsnag = Bugsnag.start({
      apiKey,
      plugins: [new BugsnagPluginReact(React)],
      // Only report errors in production or when explicitly enabled
      enabledBreadcrumbTypes: ['error', 'log', 'navigation', 'request', 'user'],
      // Add user context if available
      onError: (event: any) => {
        // Add additional context to errors
        event.addMetadata('app', {
          version: import.meta.env.VITE_APP_VERSION || '1.0.0',
          environment: import.meta.env.MODE,
        });
      },
    });

    BugsnagErrorBoundary = bugsnag.getPlugin('react')?.createErrorBoundary(React);
  } catch (error) {
    console.warn('Failed to initialize Bugsnag:', error);
  }
} else {
  console.warn('Bugsnag API key not found. Error reporting disabled.');
}

// Create a no-op function for when Bugsnag is not available
const noOpNotify = () => {};

// Export the Bugsnag instance and React Error Boundary
export { BugsnagErrorBoundary };
export default bugsnag || { notify: noOpNotify };
